<mat-card class="detail-card">
  <mat-card-content>
    @if(details(); as loan) {
      <h3 class="section-title">Loan Detail</h3>

      <h4 class="subsection-title">Balances</h4>
      <div class="detail-grid">
        <div class="detail-item">
          <strong>Principal</strong>
          <span class="detail-value">{{loan.principal | currency}}</span>
        </div>
        <div class="detail-item">
          <strong>Interest</strong>
          <span class="detail-value">{{loan.interest | currency}}</span>
        </div>
        <div class="detail-item">
          <strong>Fees</strong>
          <span class="detail-value">{{loan.fees | currency}}</span>
        </div>
        <div class="detail-item">
          <strong>Late Charges</strong>
          <span class="detail-value">{{loan.lateCharges | currency}}</span>
        </div>
        <div class="detail-item">
          <strong>Other</strong>
          <span class="detail-value">{{loan.otherCharges | currency}}</span>
        </div>
        <div class="detail-item total">
          <strong>Current Total Balance</strong>
          <span class="detail-value">{{loan.totalBalance | currency}}</span>
        </div>
      </div>

      <mat-divider class="section-divider"></mat-divider>

      <div class="detail-grid">
        <div class="detail-item">
          <strong>Payoff Amount</strong>
          <span class="detail-value">{{loan.payoffAmount | currency}}</span>
        </div>
        <div class="detail-item">
          <!-- <strong>Payoff Good Until</strong>
          <span class="detail-value">{{loan.payoffDate | date:'shortDate'}}</span> -->
        </div>
      </div>

      @if (loan.currentImpound > 0 || loan.creditLineLimit > 0) {
        <mat-divider class="section-divider"></mat-divider>
        <div class="detail-grid">
          @if (loan.currentImpound > 0) {
            <div class="detail-item">
              <strong>Current Impound</strong>
              <span class="detail-value">{{loan.currentImpound | currency}}</span>
            </div>
          }
          @if (loan.creditLineLimit > 0) {
            <div class="detail-item">
              <strong>Credit Line Limit</strong>
              <span class="detail-value">{{loan.creditLineLimit | currency}}</span>
            </div>
          }
        </div>
      }

      <mat-divider class="section-divider"></mat-divider>

      <div class="detail-grid">
        <div class="detail-item">
          <strong>Interest Rate</strong>
          <span class="detail-value">{{loan.currentRate}}%</span>
        </div>
        <div class="detail-item">
          <strong>Interest Paid YTD</strong>
          <span class="detail-value">{{loan.interestPaidYTD | currency}}</span>
        </div>
        <div class="detail-item">
          <strong>Maturity Date</strong>
          <span class="detail-value">{{loan.maturityDate | date:'shortDate'}}</span>
        </div>
      </div>
    } @else {
      <p class="no-details">No loan details available.</p>
    }
  </mat-card-content>
</mat-card>

@if(statements(); as statements) {
  <mat-card class="detail-card">
    <mat-card-content>
      <h3 class="section-title">Statements</h3>

      <!-- Primary Statement -->
      @if (statements.hasStatements && statements.primaryStatement) {
        <div>
          <div class="detail-grid">
            <div class="detail-item">
              <strong>Statement Date</strong>
              <button mat-button class="statement-link" (click)="openStatementInModal(statements.primaryStatement.documentId)">
                <mat-icon>description</mat-icon>
                {{ statements.primaryStatement.statementDate | date:'shortDate' }}
              </button>
            </div>
            <div class="detail-item">
              <strong>Due Date</strong>
              <span class="detail-value">{{ statements.primaryStatement.statementDueDate | date:'shortDate' }}</span>
            </div>
          </div>
        </div>
      }

      <!-- Year Filter Dropdown (moved below primary statement) -->
      <div class="year-filter">
        <mat-form-field appearance="outline">
          <mat-label>Year</mat-label>
          <mat-select [(value)]="selectedYear">
            <mat-option [value]="'ALL'">All</mat-option>
            @for (yr of statementYears(); track yr) {
              <mat-option [value]="yr">{{ yr }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>


      <!-- Previous Statements Filtered by Year -->
      @if (statements.statements.length > 0) {
        <div>
          <mat-divider class="section-divider"></mat-divider>
          <div class="older-statements">
            <h4 class="subsection-title">Previous Statements</h4>
            @for (stmt of filteredStatements(); track stmt) {
              <div class="detail-item">
                <a class="statement-link" target="_blank" (click)="openStatementInModal(stmt.documentId)">
                  <mat-icon>description</mat-icon>
                  {{ stmt.statementDate | date:'shortDate' }}
                </a>
              </div>
            }
          </div>
        </div>
      }

      @if (!statements.hasStatements) {
        <p>There are currently no statements for this loan.</p>
      }
    </mat-card-content>
  </mat-card>
}

<mat-card class="detail-card">
  <mat-card-content>
    <h3 class="section-title">Documents</h3>

    <div class="documents-content">
      <a (click)="openTerms()" class="documents-link">Mac Disclosure Statement & Account Customer Agreement</a>
    </div>
  </mat-card-content>
</mat-card>

<div class="actions">
  <a mat-raised-button color="primary" routerLink="../">Back</a>
</div>
